// The props the comments block draws from, built here rather than by a shell of its own.
//
// As far as the report params go the block is an open-ended question riding on the menu-test
// question: its own oe section off the block key, its cloud off the question id, and the collapse
// its strip owns. The host reads those alongside its own and hands the bag over; everything the
// block needs beyond them is built here, off the question it hangs on.

import {
  MN_COMMENTS_CHART_VIEW_MODES,
  MN_COMMENTS_HEALS_VIEW_MODE
} from '@aytm/app/stats/page/question-views/mn/components/comments-section/lib/family'

export const calcCommentsProps = ({
  id,
  questionId,
  questionKey,
  type,
  variant,
  position,
  format,
  components,
  answer,
  answerVariants,
  dimensions,
  disabled,
  clickable,
  questionChartMode,
  defaultSortOrder,
  modelDefaults,
  batch,
  link,
  isReportXpert,
  params = {},
  handlers = {}
} = {}) => ({
  id,
  // the verbatim check asks about the question the block hangs off, not about its own identity
  parentQuestionId: questionId,
  questionKey,
  type,
  variant,
  position,
  format,
  components,
  answer,
  answerVariants,
  dimensions,
  disabled,
  clickable,
  questionChartMode,
  defaultSortOrder,
  modelDefaults,
  chartViewModes: MN_COMMENTS_CHART_VIEW_MODES,
  healViewMode: MN_COMMENTS_HEALS_VIEW_MODE,
  params: { oe: params.oe, cm: params.cm, z: params.z, s: params.s, wc: params.wc, mncc: params.mncc },
  labelTarget: { id, questionId, batch },
  commentsTarget: { id, questionId, link, batch, isReportXpert },
  // a label inside the comments addresses nothing the filters can name -- there is neither a
  // chart nor an items list under them
  handlers: { ...handlers, onLabelClick: null },
  onReady: handlers.onCommentsReady,
  onStateChange: handlers.onCommentsStateChange,
  onWcParamsChange: handlers.onCommentsWcParamsChange,
  onOutdatedPreset: () => handlers.onCommentsStateChange?.('state', {}),
  onCollapsedChange: handlers.onCommentsCollapsedChange
})
